import { Tracker, type TrackerOptions } from './bundle.js';
window._tac = function(options: TrackerOptions): Tracker {
    const tracker = new Tracker(options);
    return tracker;
};
